import { Action } from 'redux-actions';

import { setErrorMessage, clearErrorMessage } from './actions';
import { ErrorMessageState } from './types';

const initialState: ErrorMessageState = null;

function errorReducer(state = initialState, action: Action<string>) {
	switch (action.type) {
		case setErrorMessage.toString():
			return action.payload;
		case clearErrorMessage.toString():
			return initialState;
		default:
			return state;
	}
}

export default errorReducer;
